import { Loader2 } from 'lucide-react';

export const PageSpinner = ({ label = 'Loading…' }: { label?: string }) => (
  <div
    className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-ink-500"
    role="status"
  >
    <Loader2 className="size-8 animate-spin text-brand-700" aria-hidden />
    <span>{label}</span>
  </div>
);
